<template>
  <div>
    <exo-table :root="_self" :formWidth="1300">
      <exo-form
        :root="_self"
        :clear="false"
        ref="constellationForm"
        :height100="true"
        class="exo-form"
      >
        <v-row
          no-gutters
          justify="space-between"
          id="form-main-row"
          style="height: 100%"
        >
          <v-col cols="6" id="inputs-col">
            <exo-input-name :root="_self" gt_PerformanceAnalysis-v-step="7" />
            <div gt_PerformanceAnalysis-v-step="27" />
            <exo-input-ref-notparametric
              :root="_self"
              name="payload"
              type="payload"
              gt_PerformanceAnalysis-v-step="8"
              componentRoute="/analyticalconstellationpayload"
              :disabled="!payloadEnabled"
            >
              <div gt_PerformanceAnalysis-v-step="28" />
              <exo-help-dialog title="Payload">
                <tooltipConstellationGeometryPayload />
              </exo-help-dialog>
            </exo-input-ref-notparametric>
            <exo-input-ref-notparametric
              :root="_self"
              name="spacecraft"
              type="spacecraft"
              componentRoute="/analyticalspacecraft"
              :disabled="!spacecraftEnabled"
            >
              <exo-help-dialog title="Spacecraft reference">
                <tooltipConstellationGeometrySpacecraft />
              </exo-help-dialog>
            </exo-input-ref-notparametric>
            <v-divider></v-divider>
            <exo-input-select
              :root="_self"
              name="constellationType"
              gt_PerformanceAnalysis-v-step="15"
            >
              <exo-help-dialog title="Constellation type">
                <tooltipConstellationGeometryConstellationType />
              </exo-help-dialog>
              <div gt_PerformanceAnalysis-v-step="16" />
              <div gt_PerformanceAnalysis-v-step="29" />
            </exo-input-select>
            <exo-input-select
              :root="_self"
              name="planeDefinitionType"
              gt_PerformanceAnalysis-v-step="17"
              :disabled="!planeDefinitionTypeEnabled"
            >
              <div gt_PerformanceAnalysis-v-step="30" />
              <exo-help-dialog title="Orbit definition">
                <tooltipConstellationGeometryOrbitDefinition />
              </exo-help-dialog>
            </exo-input-select>
            <exo-input-double :root="_self" name="jFoldCoverage">
              <exo-help-dialog title="Coverage level">
                <tooltipConstellationGeometryCoverageLevel />
              </exo-help-dialog>
            </exo-input-double>

            <v-row no-gutters v-if="walkerConstellationType">
              <v-col cols="11">
                <v-row>
                  <v-col cols="3">
                    <exo-input-double
                      :disabled="sunSynchronousOrbitType"
                      :root="_self"
                      gt_PerformanceAnalysis-v-step="18"
                      name="walkerI"
                    />
                  </v-col>
                  <v-col cols="3">
                    <exo-input-double
                      :root="_self"
                      name="walkerT"
                      gt_PerformanceAnalysis-v-step="19"
                    />
                    <div gt_PerformanceAnalysis-v-step="31" />
                  </v-col>
                  <v-col cols="3">
                    <exo-input-double
                      :root="_self"
                      name="walkerP"
                      gt_PerformanceAnalysis-v-step="20"
                    />
                    <div gt_PerformanceAnalysis-v-step="32" />
                  </v-col>
                  <v-col cols="3">
                    <exo-input-double
                      :root="_self"
                      name="walkerF"
                      gt_PerformanceAnalysis-v-step="21"
                    />
                    <div gt_PerformanceAnalysis-v-step="33" />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <exo-input-double
              v-if="!streetsOfCoverageConstellationType"
              :root="_self"
              name="altitude"
              gt_PerformanceAnalysis-v-step="22"
            />
            <div gt_PerformanceAnalysis-v-step="34" />
            <exo-form-alert
              class="mb-2"
              type="error"
              v-if="
                this.inputs.planeDefinitionType ===
                  'ALTITUDE_AND_SUN_SYNCHRONOUS' && isNotValidSSOAltitude
              "
            >
              Error: the altitude is too high. No sun-synchronous inclination
              exists at this altitude
            </exo-form-alert>
            <exo-input-double
              v-if="!walkerConstellationType"
              :root="_self"
              name="inclination"
            />
            <exo-input-select
              v-if="walkerConstellationType"
              :root="_self"
              name="definitionTypeWalker"
            />
            <v-row no-gutters>
              <v-col cols="11">
                <v-row>
                  <v-col cols="3" class="pb-0">
                    <exo-input-double :root="_self" name="n" />
                  </v-col>
                  <v-col cols="3" class="pb-0" offset-md-1>
                    <exo-input-double :root="_self" name="p" />
                  </v-col>
                  <v-col cols="3" class="pb-0" offset-md-1>
                    <exo-input-double :root="_self" name="q" />
                  </v-col>
                </v-row>
              </v-col>
              <v-col
                cols="1"
                v-if="
                  inputs.planeDefinitionType === 'PHASED_AND_INCLINATION' ||
                  inputs.planeDefinitionType === 'PHASED_AND_SUN_SYNCHRONOUS'
                "
              >
                <exo-help-dialog title="Phased orbit definition">
                  <tooltipConstellationGeometryOrbitDefinitionNPQ />
                </exo-help-dialog>
              </v-col>
              <v-row> </v-row>
            </v-row>
            <exo-form-alert
              class="mb-2"
              type="error"
              v-if="isRequiredOrOptional('p', inputs) && isPGreaterThanQ"
            >
              Error: p must be smaller than q
            </exo-form-alert>
            <exo-form-alert
              type="error"
              class="mb-2"
              v-if="errorTrace.includes('Invalid parameters for phased orbit.')"
            >
              Error: invalid parameters for phased orbit
            </exo-form-alert>

            <v-divider></v-divider>
            <exo-input-select :root="_self" name="definitionType" />

            <exo-input-double :root="_self" name="numberOfPlanes" />
            <exo-input-doubleArray :root="_self" name="initialRaans" />
            <exo-form-alert
              class="mb-2"
              type="error"
              v-if="
                this.inputs.definitionType === 'LIST_RAANS' &&
                isNotValidListOfInitialRaans
              "
            >
              Error: The number of planes is not coherent with the size of the
              list of initial RAANs
            </exo-form-alert>
            <exo-input-double :root="_self" name="firstPlaneInitialLtan" />
            <exo-input-double :root="_self" name="deltaLtan" />
            <exo-form-alert
              class="mb-2"
              type="error"
              v-if="
                this.inputs.definitionType === 'DELTA_LTAN' &&
                isNotValidDeltaLtan
              "
            >
              Error: the Number of planes and the ΔMLTAN are too high. Make sure
              that: (N-1)*ΔMLTAN &lt; 24h
            </exo-form-alert>
            <exo-input-double
              :root="_self"
              name="firstPlaneInitialRaan"
              gt_PerformanceAnalysis-v-step="23"
            />
            <div gt_PerformanceAnalysis-v-step="35" />
            <exo-input-double :root="_self" name="deltaRaan" />
            <exo-form-alert
              class="mb-2"
              type="error"
              v-if="
                this.inputs.definitionType === 'DELTA_RAAN' &&
                isNotValidDeltaRaan
              "
            >
              Error: the Number of planes and the ΔRAAN are too high. Make sure
              that: (N-1)*ΔRAAN &lt; 360°
            </exo-form-alert>
            <exo-input-double :root="_self" name="minInitialLtan" />
            <exo-input-double :root="_self" name="maxInitialLtan" />
            <exo-form-alert
              class="mb-2"
              type="error"
              v-if="
                this.inputs.definitionType === 'LINSPACE_LTAN' &&
                isNotValidMinMaxLtan
              "
            >
              Error: First plane and last plane initial MLTAN must be different
            </exo-form-alert>
            <exo-input-double :root="_self" name="minInitialRaan" />
            <exo-input-double :root="_self" name="maxInitialRaan" />
            <exo-form-alert
              class="mb-2"
              type="error"
              v-if="
                this.inputs.definitionType === 'LINSPACE_RAAN' &&
                isNotValidMinMaxRaan
              "
            >
              Error: First plane and last plane initial RAAN must be different
            </exo-form-alert>

            <v-divider></v-divider>
            <exo-input-double
              :root="_self"
              name="numberOfSpacecraftsPerPlane"
            />
            <exo-input-double
              :root="_self"
              name="firstSpacecraftInitialInOrbitPosition"
            />
            <div gt_PerformanceAnalysis-v-step="24" />
            <div gt_PerformanceAnalysis-v-step="36" />
            <exo-input-double :root="_self" name="interPlanePhasingCoefficient">
              <exo-help-dialog title="Inter-plane phasing coefficient">
                <tooltipConstellationGeometryInterplanePhasingCoefficient />
              </exo-help-dialog>
            </exo-input-double>
            <exo-form-alert
              style="margin-left: -15px"
              class="mb-2"
              type="error"
              v-if="
                isRequiredOrOptional('interPlanePhasingCoefficient', inputs) &&
                inputs.interPlanePhasingCoefficient >= inputs.numberOfPlanes
              "
            >
              Error: The inter-plane phasing coefficient must be lower than the
              total number of planes<katex-element expression="p" />.
            </exo-form-alert>
            <exo-input-double :root="_self" name="interPlanePhasing">
              <exo-help-dialog title="Inter-plane phasing">
                <tooltipConstellationGeometryInterplanePhasing />
              </exo-help-dialog>
            </exo-input-double>
            <v-row v-if="streetsOfCoverageConstellationType">
              <v-col cols="10">
                <p v-if="minAltitudeText !== ''">
                  {{ minAltitudeText }}
                </p>
                <exo-form-alert
                  :type="isNotValidSoCDefinition ? 'error' : 'info'"
                  v-if="minAltitudeErrorMessage !== ''"
                >
                  {{ minAltitudeErrorMessage }}
                </exo-form-alert>
                <v-switch
                  v-model="switchUseSoCMinAltitude"
                  inset
                  flat
                  label="Use minimum altitude as the constellation altitude"
                ></v-switch>
                <exo-input-double
                  v-if="!switchUseSoCMinAltitude"
                  :root="_self"
                  name="altitude"
                />
                <exo-form-alert
                  type="warning"
                  v-if="
                    !switchUseSoCMinAltitude &&
                    streetsOfCoverageConstellationType &&
                    inputs.altitude < minAltitudeSoCKm
                  "
                >
                  Warning: the chosen altitude is lower than the minimum
                  required. The desired {{ inputs.jFoldCoverage }}-fold coverage
                  will not be attained on the entirety of the globe.
                </exo-form-alert>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="6" id="viewer-col">
            <v-card style="padding-bottom: 90%">
              <constellation-viewer
                :constellationData="viewerData"
                :loading="computingTraces || isErrorInInputs"
                v-on:cesiumLoading="toggleFormInputs"
                ref="cesiumViewer"
              >
              </constellation-viewer>
            </v-card>
            <v-row v-if="phasedOrbitType">
              <v-col cols="10">
                <v-switch
                  v-model="switchPhasedOrbitFinder"
                  inset
                  flat
                  label="Activate Phased orbit finder"
                ></v-switch>
              </v-col>
              <v-col cols="2">
                <div class="ml-9">
                  <exo-help-dialog title="Phased orbit finder">
                    <tooltipConstellationGeometryPhasedOrbitFinder />
                  </exo-help-dialog>
                </div>
              </v-col>
              <v-col cols="12">
                <exo-card-form
                  label="Phased orbit finder"
                  v-if="switchPhasedOrbitFinder"
                >
                  <exo-npq-finder
                    :root="this"
                    :npqBuilderWatcher="npqBuilderWatcher"
                    :useSunSynchronousInclination="
                      this.inputs.planeDefinitionType ===
                      'PHASED_AND_SUN_SYNCHRONOUS'
                    "
                    :useWalkerInclination="
                      this.inputs.planeDefinitionType !==
                        'PHASED_AND_SUN_SYNCHRONOUS' && walkerConstellationType
                    "
                  />
                  <exo-form-alert
                    type="warning"
                    v-if="
                      !inputs.inclination &&
                      !walkerConstellationType &&
                      inputs.planeDefinitionType === 'PHASED_AND_INCLINATION'
                    "
                  >
                    Warning: inclination is not set.
                  </exo-form-alert>
                </exo-card-form>
              </v-col>
            </v-row>
            <v-row
              v-if="
                (walkerConstellationType ||
                  streetsOfCoverageConstellationType) &&
                Object.keys(this.implicitValues).length !== 0
              "
            >
              <v-col>
                <v-divider></v-divider>
                <v-row>
                  <v-col>
                    <h3 class="mt-2">Implicitly computed parameters</h3>
                  </v-col>
                  <v-col cols="1" class="pa-0">
                    <exo-help-dialog title="Implicitly computed parameters">
                      <tooltipConstellationGeometryImplicitParameters />
                    </exo-help-dialog>
                  </v-col>
                  <br />
                </v-row>
                <v-text-field
                  v-for="(value, field) in this.implicitValues"
                  disabled
                  :key="field"
                  :label="field"
                  :value="value"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </exo-form>
    </exo-table>
    <exo-modal-references :root="_self" :modalContent="modalRef" />
    <v-tour
      name="performanceAnalysisTourHomogeneousGeometry"
      :steps="steps_constellation_geometry"
      :callbacks="customCallbacks"
    ></v-tour>
  </div>
</template>

<script>
import Plotly from 'plotly.js-dist'
import formMixin from '../../mixins/forms.js'
import formAnalyticalMixin from '../../mixins/analyticalFoms.js'
import constellationComponentsLoader from '../../components/Forms/analyticalConstellationsComponents.js'
import { mapGetters, mapActions } from 'vuex'
import dataTools from '../../tools/data'
import fieldsDescription from '../../tools/fieldsDescription'
import tooltipConstellationGeometryPayload from '../../components/Tooltips/ConstellationGeometryForm/tooltipConstellationGeometryPayload'
import tooltipConstellationGeometrySpacecraft from '../../components/Tooltips/ConstellationGeometryForm/tooltipConstellationGeometrySpacecraft'
import tooltipConstellationGeometryConstellationType from '../../components/Tooltips/ConstellationGeometryForm/tooltipConstellationGeometryConstellationType'
import tooltipConstellationGeometryImplicitParameters from '../../components/Tooltips/ConstellationGeometryForm/tooltipConstellationGeometryImplicitParameters'
import tooltipConstellationGeometryOrbitDefinition from '../../components/Tooltips/ConstellationGeometryForm/tooltipConstellationGeometryOrbitDefinition'
import tooltipConstellationGeometryOrbitDefinitionNPQ from '../../components/Tooltips/ConstellationGeometryForm/tooltipConstellationGeometryOrbitDefinitionNPQ'
import tooltipConstellationGeometryInterplanePhasingCoefficient from '../../components/Tooltips/ConstellationGeometryForm/tooltipConstellationGeometryInterplanePhasingCoefficient'
import tooltipConstellationGeometryInterplanePhasing from '../../components/Tooltips/ConstellationGeometryForm/tooltipConstellationGeometryInterplanePhasing'
import tooltipConstellationGeometryPhasedOrbitFinder from '../../components/Tooltips/ConstellationGeometryForm/tooltipConstellationGeometryPhasedOrbitFinder'
import tooltipConstellationGeometryCoverageLevel from '../../components/Tooltips/ConstellationGeometryForm/tooltipConstellationGeometryCoverageLevel'
import constellationViewer from './ConstellationViewer.vue'
import guidedTutorialPerformanceAnalysis, {
  steps_constellation_geometry
} from '../../components/GuidedTutorials/guidedTutorialPerformanceAnalysis.js'

constellationComponentsLoader()

export default {
  name: 'AnalyticalConstellationHomogeneousGeometry',

  components: {
    tooltipConstellationGeometryPayload,
    tooltipConstellationGeometrySpacecraft,
    tooltipConstellationGeometryConstellationType,
    tooltipConstellationGeometryImplicitParameters,
    tooltipConstellationGeometryOrbitDefinition,
    tooltipConstellationGeometryOrbitDefinitionNPQ,
    tooltipConstellationGeometryInterplanePhasingCoefficient,
    tooltipConstellationGeometryInterplanePhasing,
    tooltipConstellationGeometryPhasedOrbitFinder,
    tooltipConstellationGeometryCoverageLevel,
    constellationViewer
  },

  mixins: [formMixin, formAnalyticalMixin],

  mounted() {
    this.refreshReferences()
    if (this.paramsValid) {
      this.computeEphemerisTraces()
    }
    if (this.streetsOfCoverageConstellationType) {
      this.inputs.planeDefinitionType = 'ALTITUDE_AND_INCLINATION'
    }
    if (this.gt_PerformanceAnalysis.isActive) {
      guidedTutorialPerformanceAnalysis.beginConstellationHomogeneousGeometryTour(
        this
      )
    }
  },

  beforeDestroy() {
    try {
      Plotly.purge(this.drawingDomName)
    } catch (_) {}
  },

  data() {
    return {
      tableFields: [
        { value: 'displayedName', text: 'Name', sortable: true },
        {
          value: 'constellationType',
          text: 'Constellation type',
          sortable: true
        },
        {
          value: 'definitionType',
          text: 'Plane definition type',
          sortable: true
        },
        { value: 'numberOfPlanes', text: 'Planes', sortable: true },
        {
          value: 'numberOfSpacecraftsPerPlane',
          text: 'Spacecrafts per plane',
          sortable: true
        },
        {
          value: 'altitude',
          text: 'Altitude' + this.getDefaultUnitLabel('altitude'),
          sortable: true
        },
        {
          value: 'inclination',
          text: 'Inclination' + this.getDefaultUnitLabel('inclination'),
          sortable: true
        },
        { value: 'payload', text: 'Payload', sortable: true },
        { value: 'spacecraft', text: 'Spacecraft', sortable: true },
        { value: 'actions', text: 'Actions', sortable: false }
      ],

      enumPropertiesList: this.getEnumProperties(),

      modalRef: { content: [] },
      showModal: false,

      switchPhasedOrbitFinder: false,
      switchUseSoCMinAltitude: true,
      minAltitudeSoCKm: null,
      minAltitudeText: '',
      minAltitudeErrorMessage: '',

      payloadsNotParametrics: [],
      spacecraftsNotParametrics: [],

      tracesResults: {},
      viewerData: {},

      errorTrace: '',

      steps_constellation_geometry: steps_constellation_geometry,
      customCallbacks: {
        onNextStep: (currentStep) => {
          guidedTutorialPerformanceAnalysis.onNextStepHomogeneousGeometry(
            currentStep,
            this
          )
        },
        onSkip: () => {
          guidedTutorialPerformanceAnalysis.onSkipHomogeneousGeometry(this)
        },
        onFinish: () => {
          guidedTutorialPerformanceAnalysis.onFinishSubmit(this)
        }
      },

      inputs: {
        name: this.getDefaultValue('name'),
        description: this.getDefaultValue('description'),
        spacecraft: null,
        constellationType: this.getDefaultValue('constellationType'),
        definitionType: this.getDefaultValue('definitionType'),
        definitionTypeWalker: this.getDefaultValue('definitionTypeWalker'),
        interPlanePhasing: this.getDefaultValue('interPlanePhasing'),
        numberOfPlanes: this.getDefaultValue('numberOfPlanes'),
        numberOfSpacecraftsPerPlane: this.getDefaultValue(
          'numberOfSpacecraftsPerPlane'
        ),
        planeDefinitionType: this.getDefaultValue('planeDefinitionType'),
        altitude: this.getDefaultValue('altitude'),
        inclination: this.getDefaultValue('inclination'),
        n: this.getDefaultValue('n'),
        p: this.getDefaultValue('p'),
        q: this.getDefaultValue('q'),
        payload: null,
        firstPlaneInitialLtan: this.getDefaultValue('firstPlaneInitialLtan'),
        deltaLtan: this.getDefaultValue('deltaLtan'),
        minInitialLtan: this.getDefaultValue('minInitialLtan'),
        maxInitialLtan: this.getDefaultValue('maxInitialLtan'),
        firstPlaneInitialRaan: this.getDefaultValue('firstPlaneInitialRaan'),
        deltaRaan: this.getDefaultValue('deltaRaan'),
        minInitialRaan: this.getDefaultValue('minInitialRaan'),
        maxInitialRaan: this.getDefaultValue('maxInitialRaan'),
        firstSpacecraftInitialInOrbitPosition: this.getDefaultValue(
          'firstSpacecraftInitialInOrbitPosition'
        ),
        visualizationDate: this.getDefaultValue('visualizationDate'),
        interPlanePhasingCoefficient: this.getDefaultValue(
          'interPlanePhasingCoefficient'
        ),
        maxQ: this.getDefaultValue('qMax'),
        minQ: this.getDefaultValue('qMin'),
        minAltitude: this.getDefaultValue('altitudeMin'),
        maxAltitude: this.getDefaultValue('altitudeMax'),
        walkerI: this.getDefaultValue('walkerI'),
        walkerT: this.getDefaultValue('walkerT'),
        walkerP: this.getDefaultValue('walkerP'),
        walkerF: this.getDefaultValue('walkerF'),
        initialRaans: this.getDefaultValue('initialRaans'),
        jFoldCoverage: this.getDefaultValue('jFoldCoverage'),
        scope: this.getDefaultValue('scope')
      },
      computingTraces: false,
      isRecording: false,
      showDialog: false,
      showFieldOfRegard: false,
      showSwath: false,
      showTimeline: true,
      sceneMode2D: false,
      implicitValues: {}
    }
  },

  methods: {
    ...mapActions(['setCurrentMission']),

    toggleFormInputs(isLoading) {
      let form = this.$refs.constellationForm.$el
      let inputs = form.querySelectorAll('input')
      for (let i = 0; i < inputs.length; i++) {
        inputs[i].readOnly = isLoading
      }
    },

    refreshReferences() {
      this.refreshSpacecrafts()
      this.refreshPayloads()
    },

    checkboxClicked() {
      if (!this.showFieldOfRegard && this.shouldDialogTrigger) {
        this.showDialog = true
      } else {
        this.showFieldOfRegard = !this.showFieldOfRegard
      }
    },

    async computeEphemerisTraces() {
      this.computingTraces = true
      this.implicitValues = {}
      if (!this.inputs.visualizationDate) {
        this.inputs.visualizationDate =
          this.getDefaultValue('visualizationDate')
      }
      let data = await this.$http
        .post('/physics/constellationorbittraces', this.createObjectFromForm())
        .then(function (response) {
          return response.data
        })
        .catch((e, response) => {
          this.errorTrace = this.getErrorMessage(e)
          return null
        })
      if (data == null) {
        this.tracesResults = null
      } else {
        this.errorTrace = ''
        let result = {
          traces: [data.ephemeridesTraces],
          payloads: [data?.payload?.fieldOfView]
        }
        this.tracesResults = result
        this.viewerData = {
          altitude: data.plane.altitude,
          period: data.plane.keplerianPeriod,
          intraPlanePhasing: data.intraPlanePhasing,
          interPlanePhasing: data.interPlanePhasing,
          traces: data.ephemeridesTraces,
          payloads: data?.payload?.fieldOfView,
          initialDate: this.inputs.visualizationDate,
          numberOfSpacecraftsPerPlane: data.numberOfSpacecraftsPerPlane,
          numberOfPlanes: data.numberOfPlanes
        }
      }
      this.updateImplicitValues(data)
      this.computingTraces = false
    },

    updateImplicitValues(data) {
      if (data == null) {
        return
      }

      let implicitFields = []
      if (
        this.streetsOfCoverageConstellationType ||
        this.walkerConstellationType
      ) {
        implicitFields = ['deltaRaan', 'interPlanePhasing']
      }
      for (let field of implicitFields) {
        this.implicitValues[
          this.getFormLabel(field) + this.getDefaultUnitLabel(field)
        ] = dataTools.convertSi2Display(this.getFieldType(field), data[field])
      }
    },

    refreshSpacecrafts() {
      let self = this
      this.$http
        .get(this.getAPI('parametricspacecraftdefinitions'))
        .then((response) => {
          self.spacecraftsNotParametrics = response.data
            .filter((obj) => !obj.displayedName.endsWith('*'))
            .map((obj) => ({ value: obj, text: obj.displayedName }))
            .sort((a, b) =>
              a.text.toLowerCase() < b.text.toLowerCase() ? -1 : 1
            )
        })
        .catch((e) => {
          self.displayMessage(
            'Error getting list of spacecrafts. ',
            e,
            'NumericalMissionErrorDisplay',
            'error'
          )
        })
    },

    refreshPayloads() {
      // TODO MFI automatic method for all of these getters
      let self = this
      this.$http
        .get(this.getAPI(`payloaddefinitions`))
        .then((response) => {
          self.payloadsNotParametrics = response.data
            .map((obj) => ({ value: obj, text: obj.displayedName }))
            .sort((a, b) =>
              a.text.toLowerCase() < b.text.toLowerCase() ? -1 : 1
            )
        })
        .catch((e) => {
          self.displayMessage(
            'Error getting list of payloads. ',
            e,
            'notification',
            'error'
          )
        })
    },

    getRequiredPropertiesList(instance) {
      let subTypes = this.getSubTypes(instance)
      let objectType = this.getCurrentFormType()
      let requiredList = dataTools.getPropertiesList(
        fieldsDescription[objectType],
        subTypes,
        'required'
      )
      return requiredList
    },

    getFieldState(parentObject, fieldName, required) {
      let fieldState = formAnalyticalMixin.methods.getFieldState.call(
        this,
        parentObject,
        fieldName,
        required
      )
      if (
        fieldState.value === true &&
        fieldName === 'constellationType' &&
        parentObject[fieldName] === 'STREETS_OF_COVERAGE'
      ) {
        if (this.isNotValidSoCDefinition) {
          fieldState.value = false
          fieldState.message = this.minAltitudeErrorMessage
        }
      }

      return fieldState
    },

    getOptionalPropertiesList(instance) {
      let subTypes = this.getSubTypes(instance)
      let objectType = this.getCurrentFormType()
      return dataTools.getPropertiesList(
        fieldsDescription[objectType],
        subTypes,
        'optional'
      )
    },

    getSubTypes(instance) {
      let types = {
        constellationType: instance.constellationType,
        planeDefinitionType: instance.planeDefinitionType,
        definitionType: instance.definitionType,
        definitionTypeWalker: instance.definitionTypeWalker
      }
      return types
    },

    getAllPropertiesUnionList() {
      let objectType = this.getCurrentFormType()
      let requiredList = dataTools.getPropertiesList(
        fieldsDescription[objectType],
        null,
        'required'
      )
      let optionalList = dataTools.getPropertiesList(
        fieldsDescription[objectType],
        null,
        'optional'
      )
      return [...new Set(requiredList.concat(optionalList))]
    },

    getCurrentFormTitle() {
      return 'Constellation geometry'
    },

    getCurrentFormType() {
      return 'SubConstellationDefinition'
    },

    getRefList(param) {
      if (param === 'spacecraft') {
        return this.spacecraftsNotParametrics
      }
      if (param === 'payload') {
        return this.payloadsNotParametrics
      }
    },

    async computeMinimumSoCAltitude() {
      let self = this
      let data = await this.$http
        .post('/physics/computeminsocaltitude', this.createObjectFromForm())
        .then(function (response) {
          return response.data
        })
        .catch((e, response) => {
          let error
          if (e.response?.status == 400) {
            error = e.response.data
            if (error?.message != null) {
              error = error.message
            }
          } else {
            error = this.getErrorMessage(e)
          }
          return error
        })
      if (typeof data === 'number') {
        this.minAltitudeSoCKm = Math.ceil(data / 1e3)
        this.minAltitudeText =
          'Minimum altitude required for desired coverage: ' +
          this.minAltitudeSoCKm +
          ' km'
        this.minAltitudeErrorMessage = ''
      } else {
        this.minAltitudeSoCKm = null
        this.minAltitudeText = ''
        this.minAltitudeErrorMessage = data
      }
      if (this.switchUseSoCMinAltitude === true) {
        this.inputs.altitude = this.minAltitudeSoCKm
      }
    }
  },
  computed: {
    ...mapGetters(['currentMission', 'gt_PerformanceAnalysis']),

    shouldDialogTrigger() {
      return this.inputs.numberOfPlanes *
        this.inputs.numberOfSpacecraftsPerPlane >
        24
        ? true
        : false
    },

    isPGreaterThanQ() {
      return Number(this.inputs.p) >= Number(this.inputs.q)
    },

    isNotValidSSOAltitude() {
      let earthJ2 = 0.00108262668355315
      let earthRadius = 6378.1363
      let earthMu = 3.986004415e14
      let earthRotationRate = 1.99099300639395e-7
      let K =
        (-3.0 * earthJ2 * Math.pow(earthRadius * 1e3, 2) * Math.sqrt(earthMu)) /
        (2.0 * earthRotationRate)
      let semiMajorAxis = earthRadius + Number(this.inputs.altitude)
      let maxSMA = Math.pow(-K, 2.0 / 7.0)
      if (semiMajorAxis * 1e3 > maxSMA) {
        return true
      } else {
        return false
      }
    },

    isNotValidDeltaLtan() {
      let day = 86400.0
      if (
        (this.inputs.numberOfPlanes - 1) *
          dataTools.convertGui2si('timeHMS', this.inputs.deltaLtan) >
        day
      ) {
        return this.inputs.definitionType === 'DELTA_LTAN' ? true : false
      } else {
        return false
      }
    },

    isNotValidDeltaRaan() {
      if ((this.inputs.numberOfPlanes - 1) * this.inputs.deltaRaan > 360) {
        return this.inputs.definitionType === 'DELTA_RAAN' ? true : false
      } else {
        return false
      }
    },

    isNotValidMinMaxLtan() {
      if (
        this.inputs.minInitialLtan != '' &&
        this.inputs.maxInitialLtan == this.inputs.minInitialLtan
      ) {
        return this.inputs.definitionType === 'LINSPACE_LTAN' ? true : false
      } else {
        return false
      }
    },

    isNotValidMinMaxRaan() {
      if (
        this.inputs.minInitialRaan != '' &&
        this.inputs.maxInitialRaan == this.inputs.minInitialRaan
      ) {
        return this.inputs.definitionType === 'LINSPACE_RAAN' ? true : false
      } else {
        return false
      }
    },

    isNotValidListOfInitialRaans() {
      if (this.inputs.initialRaans.length != this.inputs.numberOfPlanes) {
        return this.inputs.definitionType === 'LIST_RAANS' ? true : false
      } else {
        return false
      }
    },

    isNotValidSoCDefinition() {
      if (this.inputs.constellationType == 'STREETS_OF_COVERAGE') {
        if (this.minAltitudeErrorMessage == null) {
          return false
        }
        return this.minAltitudeErrorMessage.toString().startsWith('Error')
      } else {
        return false
      }
    },

    isErrorInInputs() {
      if (
        (this.isNotValidSSOAltitude &&
          (this.inputs.planeDefinitionType ===
            '"ALTITUDE_AND_SUN_SYNCHRONOUS"' ||
            this.inputs.planeDefinitionType ===
              'PHASED_AND_SUN_SYNCHRONOUS')) ||
        this.isNotValidDeltaLtan ||
        this.isNotValidDeltaRaan ||
        this.isNotValidMinMaxLtan ||
        this.isNotValidMinMaxRaan ||
        this.isNotValidListOfInitialRaans ||
        this.isNotValidSoCDefinition
      ) {
        return true
      } else {
        return false
      }
    },

    payloadEnabled() {
      return (
        this.currentMission?.typeName ===
          'ConstellationPerformanceAnalysisRequest' ||
        this.currentMission?.typeName === 'ConstellationOptimizationRequest' ||
        this.currentMission?.typeName === 'ConstellationSimulationRequest' ||
        this.currentMission?.typeName === 'ConstellationGenerationRequest' ||
        this.streetsOfCoverageConstellationType
      )
    },

    spacecraftEnabled() {
      return (
        this.currentMission?.typeName === 'DeploymentRequest' ||
        this.currentMission?.typeName === 'ConstellationOptimizationRequest' ||
        this.currentMission?.typeName === 'ConstellationGenerationRequest'
      )
    },

    planeDefinitionTypeEnabled() {
      return this.inputs.constellationType !== 'STREETS_OF_COVERAGE'
    },

    wrongLastPlane() {
      if (this.definitionType === this.DELTA_RAAN) {
        return (this.numberOfPlanes - 1) * this.deltaRaan < '2PI'
      } else {
        return (this.numberOfPlanes - 1) * this.deltaLtan < 24
      }
    },
    npqBuilderWatcher() {
      return [
        this.inputs.constellationType,
        this.inputs.planeDefinitionType,
        this.inputs.walkerI,
        this.inputs.inclination,
        this.inputs.minAltitude,
        this.inputs.maxAltitude,
        this.inputs.minQ,
        this.inputs.maxQ
      ]
    },
    traceBuilderWatcher() {
      // all fields because if one field not related in error, the form need to be updated once result OK
      return [
        this.inputs.spacecraft,
        this.inputs.constellationType,
        this.inputs.definitionType,
        this.inputs.definitionTypeWalker,
        this.inputs.interPlanePhasing,
        this.inputs.numberOfPlanes,
        this.inputs.numberOfSpacecraftsPerPlane,
        this.inputs.planeDefinitionType,
        this.inputs.altitude,
        this.inputs.inclination,
        this.inputs.n,
        this.inputs.p,
        this.inputs.q,
        this.inputs.walkerI,
        this.inputs.walkerT,
        this.inputs.walkerP,
        this.inputs.walkerF,
        this.inputs.payload,
        this.inputs.initialRaans,
        this.inputs.firstPlaneInitialLtan,
        this.inputs.deltaLtan,
        this.inputs.minInitialLtan,
        this.inputs.maxInitialLtan,
        this.inputs.firstPlaneInitialRaan,
        this.inputs.deltaRaan,
        this.inputs.minInitialRaan,
        this.inputs.maxInitialRaan,
        this.inputs.firstSpacecraftInitialInOrbitPosition,
        this.inputs.visualizationDate
      ]
    },
    minimumSoCAltitudeWatcher() {
      return [
        this.inputs.jFoldCoverage,
        this.inputs.inclination,
        this.inputs.numberOfPlanes,
        this.inputs.numberOfSpacecraftsPerPlane,
        this.inputs.payload,
        this.inputs.constellationType
      ]
    },
    phasedOrbitType() {
      return (
        this.inputs.planeDefinitionType === 'PHASED_AND_INCLINATION' ||
        this.inputs.planeDefinitionType === 'PHASED_AND_SUN_SYNCHRONOUS'
      )
    },
    sunSynchronousOrbitType() {
      return (
        this.inputs.planeDefinitionType === 'PHASED_AND_SUN_SYNCHRONOUS' ||
        this.inputs.planeDefinitionType === 'ALTITUDE_AND_SUN_SYNCHRONOUS'
      )
    },
    walkerConstellationType() {
      return (
        this.inputs.constellationType === 'WALKER_DELTA' ||
        this.inputs.constellationType === 'WALKER_STAR'
      )
    },
    streetsOfCoverageConstellationType() {
      return this.inputs.constellationType === 'STREETS_OF_COVERAGE'
    },
    displayNPQPlot() {
      return (
        ((this.inputs.planeDefinitionType === 'PHASED_AND_INCLINATION' &&
          this.inputs.walkerI != null) ||
          this.inputs.planeDefinitionType === 'PHASED_AND_SUN_SYNCHRONOUS') &&
        this.inputs.minAltitude != null &&
        this.inputs.maxAltitude != null &&
        this.inputs.minQ != null &&
        this.inputs.maxQ != null
      )
    }
  },

  watch: {
    traceBuilderWatcher: function (value) {
      if (this.paramsValid) {
        setTimeout(() => {
          this.computeEphemerisTraces()
        }, 500)
      }
    },
    switchPhasedOrbitFinder(isActivated) {
      let viewerCol =
        this.$refs.constellationForm.$el.querySelector('#viewer-col')
      const scrollValue = isActivated ? viewerCol.scrollHeight : 0
      setTimeout(
        () => {
          viewerCol.scrollTop = scrollValue
        },
        scrollValue ? 100 : 0
      )
    },
    switchUseSoCMinAltitude(isActivated) {
      if (isActivated === true) {
        this.inputs.altitude = this.minAltitudeSoCKm
      }
    },
    streetsOfCoverageConstellationType(isSoC) {
      if (isSoC) {
        this.inputs.planeDefinitionType = 'ALTITUDE_AND_INCLINATION'
      }
    },
    minimumSoCAltitudeWatcher: function (value) {
      if (this.streetsOfCoverageConstellationType === true) {
        if (this.inputs.altitude === '' || this.inputs.altitude == null) {
          // give a valid altitude just to allow the computation of min altitude
          this.inputs.altitude = 1000
        }

        setTimeout(() => {
          this.computeMinimumSoCAltitude()
        }, 100)
      }
    },
    'inputs.displayForm': {
      handler(show) {
        if (!show) this.$refs.cesiumViewer.clearVisualElements()
      }
    }
  }
}
</script>
<style scoped lang="scss">
.exo-form {
  display: grid;
  height: 80vh;
  grid-template-rows: 10% 80% 1% 9%;
  overflow: hidden;
}

#inputs-col,
#viewer-col {
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0 15px;
  // seems silly to use calc with -0px but otherwise the div does not scroll to the end
  height: calc(100% - 0px);
  scrollbar-color: rgba(255, 255, 255, 0.75) #444;
  scrollbar-width: thin;
  transition: all linear 0.3s;
  scroll-behavior: smooth;
  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-track {
    background-color: #444;
    border-radius: 100px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.75);
    border-radius: 100px;
  }
}

#inputs-col {
  direction: rtl;
  .row {
    direction: ltr;
  }
}
</style>
